@let properties = settings.schemaObject;

@if (passedFormControl()) {
  <div class="form-group label-static is-empty"
       [class.is-focused]="$any(input).isFocused"
       [class.has-success]="!formErrors() && passedFormControl().valid"
       [class.has-error]="((!passedFormControl().valid && passedFormControl().touched) || formErrors())">
    @if (showLabel()) {
      <label [htmlFor]="'member_form_msisdn'" class="control-label">
        <span>{{ 'generic.phone_number' | translate }}</span>
        @if (controlName() && properties?.isRequiredOrIdentifier(controlName())) {
          <span class="required">*</span>
        }
      </label>
    }
    <div [class.input-group]="readonly() && icon()">
      <input [readonly]="readonly()"
             [required]="required()"
             #input
             appFocusable (onFocusChange)="$any(input).isFocused = $event"
             appMsisdnInput
             [formControl]="passedFormControl()"
             [autoPrependWithPlus]="autoPrependWithPlus()"
             [name]="settings.slug + '_msisdn'"
             class="form-control"
             type="tel"
             [id]="id"
             [controlUID]="controlUID"
             autocomplete="off"/>
      @if (readonly() && icon()) {
        <span class="input-group-btn">
          <button class="btn btn-default" type="button" (click)="editClicked.emit(true); input.focus()"><i
              class="icon icon-pencil" aria-hidden="true"></i></button>
        </span>
      }
    </div>
    @if (showErrors()) {
      <app-input-errors [errorsForField]="formErrors()"
                        [translationKey]="'errors.members'"/>
    }
  </div>
}
